export const VARS = {
  price: {
    yearly: '$119',
    yearlyDisplay: '$119',
    monthly: '$10',
    monthlyDisplay: 'less than $10'
  },
  cta: {
    message: 'Join Catch',
  },
  subscription: {
    defaultAmount: 11900, // $119.00 in cents
    defaultInterval: 'year' as const,
    defaultIntervalCount: 1,
  },
};
